import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import "../../../CommonScss/QuotePage.scss";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import DatePicker from "../../../Components/Common/FieldTypes/DatePicker/DatePicker";
import RKTextField from "../../../Components/Common/FieldTypes/RKTextField/RKTextField";
import SelectDropdown from "../../../Components/Common/FieldTypes/SelectDropdown/SelectDropdown";
import GreyBoxTitle from "../../../Components/Desktop/GreyBoxTitle/GreyBoxTitle";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { PATH } from "../../../shared/Path";
import { useNavigate } from "react-router-dom";

function NomineeDetails() {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState<{
    fullName: { value: string; warning: boolean };
    gender: { value: string; warning: boolean };
    NomineeDob: { value: Date | null; warning: boolean };
    relationshipwithInsured: { value: Date | null; warning: boolean };
    mobile: { value: string; warning: boolean };
    trusteeName: { value: string; warning: boolean };
  }>({
    fullName: { value: "", warning: false },
    gender: { value: "", warning: false },
    NomineeDob: { value: null, warning: false },
    relationshipwithInsured: { value: null, warning: false },
    mobile: { value: "", warning: false },
    trusteeName: { value: "", warning: false },
  });

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName[3]({
      ...attrName[2],
      [attrName[0]]: { ...[attrName[0]], [attrName[1]]: value },
    });
  };

  return (
    <Box className="quoteWrapper">
      <QuoteNavbar />
      <Grid container spacing={3}>
        <Grid xs maxWidth="300px">
          <div className="ctaBtn mb-4">
            <CustomButton
              class_name="backBtn"
              text_name="Back"
              onClickFunction={() => {
                navigate(-1);
              }}
            />
          </div>
          <Box className="lefSidebar">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div>
                <p>Travellers:</p>
                <h6>4 Members</h6>
              </div>
              <div>
                <p>Travelling to:</p>
                <h6>England, Canada</h6>
              </div>
              <div>
                <p>Departure on:</p>
                <h6>Dec 6, 2023</h6>
              </div>
              <div>
                <p>Return on:</p>
                <h6>Dec 26, 2023</h6>
              </div>
            </div>
            <Box className="whiteBox">
              <p
                style={{
                  borderBottom: "1px solid #6458D8",
                  marginBottom: "12px",
                }}
              >
                Worldwide Travel Policy
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h5
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#6458D8",
                  }}
                >
                  ₹ 1,024
                </h5>
                <p>+ Taxes</p>
              </div>
            </Box>
          </Box>
        </Grid>
        <Grid xs>
          <>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <GreyBoxTitle title="Nominee Details" />
              </Grid>
              <Grid xs={12}></Grid>
            </Grid>

            {/* If other selected */}
            <Grid container spacing={3}>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Full Name"}
                  value={formFields.fullName.value}
                  attrName={["fullName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.fullName.warning}
                />
              </Grid>
              <Grid xs={4}>
                <SelectDropdown
                  class_name="inputField"
                  title="Gender"
                  value={formFields.gender.value}
                  attrName={["gender", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  dropdown_data={gender_data}
                  warn_status={formFields.gender.warning}
                />
              </Grid>
              <Grid xs={4}>
                <DatePicker
                  class_name="inputField datepicker"
                  title={"DOB"}
                  value={formFields.NomineeDob.value}
                  attrName={["NomineeDob", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  error_message=""
                  warn_status={formFields.NomineeDob.warning}
                />
              </Grid>
              <Grid xs={5}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Relationship with Insured"}
                  value={formFields.relationshipwithInsured.value}
                  attrName={[
                    "relationshipwithInsured",
                    "value",
                    formFields,
                    setFormFields,
                  ]}
                  value_update={updateMasterState}
                  warn_status={formFields.relationshipwithInsured.warning}
                />
              </Grid>
              <Grid xs={3}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"Mobile"}
                  value={formFields.mobile.value}
                  attrName={["mobile", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.mobile.warning}
                />
              </Grid>
              <Grid xs={4}>
                <RKTextField
                  class_name="inputField mb-2"
                  title={"If under 18, Trustee Name"}
                  value={formFields.trusteeName.value}
                  attrName={["trusteeName", "value", formFields, setFormFields]}
                  value_update={updateMasterState}
                  warn_status={formFields.trusteeName.warning}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid xs={12} className="ctaBtn text-center">
                <CustomButton
                  onClickFunction={() => {
                    navigate(PATH.MEDICAL_DETAILS);
                  }}
                  text_name="Continue"
                  class_name="blueXlBtn"
                />
              </Grid>
            </Grid>
          </>
        </Grid>
      </Grid>
    </Box>
  );
}

export default NomineeDetails;
